import React  from 'react';
import Modal from '@material-ui/core/Modal';
import ClearIcon from '@material-ui/icons/Clear';

import { ModalWrapper, ModalDescription, SignInButton } from './styles';

export function ExistingEmailErrorModal({ isModalEmailError, handleCloseEmailError }) {

  return (
    <Modal
      open={isModalEmailError}
      onClose={handleCloseEmailError}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
      disableBackdropClick 
    >
      <ModalWrapper>
        <ModalDescription id="success-modal-description">
          A nova senha deve ser diferente da senha atual.
          <ClearIcon style={{ color: 'red', marginLeft: 0, fontSize: '33px' }} />
        </ModalDescription>
        <SignInButton type="button" onClick={handleCloseEmailError}>
          <span> Voltar </span>
        </SignInButton>
      </ModalWrapper>
    </Modal>
  );
}
